<template>
  <tr class="cat-my-item myItemRow" valign="middle">
    <td>
      <div class="item-row">
        <cat-icon
          v-if="icon"
          class="item-icon"
          :icon="icon"
          :iconLabel="iconLabel ? iconLabel : icon"
        ></cat-icon>
        <div class="clearfix">
          <div v-if="header">
            <small class="myItemApp">{{ header }}</small>
          </div>
          <div v-else-if="app">
            <small class="myItemApp">{{ app }}</small>
          </div>
          <span
            class="myItemName prt text-highlight"
            :data-label="app ? app.toUpperCase() : null"
            ><slot></slot
          ></span>
          <div v-if="itemNumber">
            <small class="myItemNumber">
              <i>({{ itemNumber }})</i></small
            >
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script lang="ts">
import CatIcon from "../utilities/catIcon";
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatMyItem",
  components: { CatIcon },
  props: {
    id: {
      type: [String, Number]
    },
    itemName: String,
    itemNumber: String,
    status: String,
    date: String,
    app: String,
    header: String,
    icon: String,
    iconLabel: String
  }
});
</script>
